var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.summary},scopedSlots:_vm._u([{key:"cell(price)",fn:function(row){return [_vm._v(" $ "+_vm._s((row.value / 100).toFixed(2))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }